import { Reducer } from 'redux';
import { DatesState, DatesTypes } from './types';

const INITIAL_STATE: DatesState = {
  startedAt: new Date(),
  isStartedAt: new Date(),
  selectedStartDate: new Date(),
  selectedEndDate: new Date(),
  loading: false,
  error: false,
};

const reducer: Reducer<DatesState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES SELECTED IS STARTED AT
    case DatesTypes.SET_SELECTED_IS_STARTED_AT:
      return {
        ...state,
        loading: false,
        error: false,
        selectedIsStartedAt: action.payload.selectedIsStartedAt,
      };

      // CASES SELECTED STARTED AT
    case DatesTypes.SET_SELECTED_STARTED_AT:
      return {
        ...state,
        loading: false,
        error: false,
        selectedStartedAt: action.payload.selectedStartedAt,
      };

    // CASES SELECTED START DATE
    case DatesTypes.SET_SELECTED_START_DATE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedStartDate: action.payload.selectedStartDate,
      };

    // CASES SELECTED END DATE
    case DatesTypes.SET_SELECTED_END_DATE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedEndDate: action.payload.selectedEndDate,
      };

    default:
      return state;
  }
};

export default reducer;
